/* import __COLOCATED_TEMPLATE__ from './emoji.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore
import { cached } from 'tracked-toolbox';
import { getEmojiItemList, wrapInColons, hasNativeEmojiSupport, applySkinTone } from '@intercom/embercom-prosemirror-composer/lib/helpers/emoji';
let EmojiInserter = (_class = class EmojiInserter extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "emojiSize", 16);
    _defineProperty(this, "emojiImageClass", 'emoji__image');
  }
  get skinToneModifier() {
    return this.args.composer.config.skinToneModifier;
  }
  get emojiItems() {
    return getEmojiItemList(this.skinToneModifier, true);
  }
  get filteredEmoji() {
    if (!this.args.matchResult) {
      return [];
    }
    if (this.args.matchResult.text.length === 1) {
      return this.emojiItems;
    }
    let matchWithoutTrigger = this.args.matchResult.text.replace(':', '');
    let escapedMatch = this.escapeRegex(matchWithoutTrigger);
    let regexp = new RegExp(`^${escapedMatch}`, 'i');
    return this.emojiItems.filter(item => regexp.test(item.identifier));
  }
  escapeRegex(string) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
  }
  insertEmoji(item) {
    if (this.args.matchResult) {
      let text = `${hasNativeEmojiSupport() ? applySkinTone(item.unicodeIcon, this.skinToneModifier) : wrapInColons(item.identifier)} `;
      this.args.composer.commands.insertTextAtRange(this.args.matchResult?.range, text);
      this.args.composer.commands.focus();
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "emojiItems", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "emojiItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredEmoji", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "filteredEmoji"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertEmoji", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertEmoji"), _class.prototype)), _class);
export { EmojiInserter as default };